import { cloneDeep } from 'lodash';

export function separerEcheanceParProduitAchat(echeances) {
  return echeances.map(echeance => {
    return echeance.listeProduitsLocationEtDivers.map(produit => {
      const newEcheance = cloneDeep(echeance);
      delete newEcheance.listeProduitsLocationEtDivers;
      newEcheance.produitLocationEtDivers = produit;
      return newEcheance;
    });
  }).flat(2);
}

export function grouperEcheanceAvecProduitAchat(echeances) {
  const groupedEcheances = [];
  echeances.forEach(echeance => {
    const groupedEcheance = groupedEcheances.find(ech => ech.key === echeance.key);
    if (groupedEcheance) {
      groupedEcheance.listeProduitsLocationEtDivers.push(echeance.produitLocationEtDivers);
    } else {
      const newGroupedEcheance = cloneDeep(echeance);
      newGroupedEcheance.listeProduitsLocationEtDivers = [echeance.produitLocationEtDivers];
      delete newGroupedEcheance.produitLocationEtDivers;
      groupedEcheances.push(newGroupedEcheance);
    }
  });
  return groupedEcheances;
}
